export const os_type_enum = [
  "IOS",
  "ANDROID",
];
